<div
    class="result-tag font-sm d-flex align-items-center"
    [ngClass]="outline ? ['outline', resultClass] : [resultClass]"
>
    {{ activityResultTypeToText(result) }}
</div>
